import { Container, Paper, Typography } from "@mui/material";

export const parseSentimentData = (data) => {
    const questions = data.reduce((acc, item) => {
        const key = item.session_id;
        if (!acc[key]) {
          acc[key] = {
            program_name: item.program_name,
            session_date : item.session_date,
            first_name : item.first_name,
            tutor_id: item.tutor_id,
            responses: [],
            positiveCount: 0,
            totalCount: 0,
            sentimentSum: 0
          };
        }
        
        acc[key].responses.push(item);
        acc[key].totalCount++;
        
        if (item.sentiment_score > 0.1) {
          acc[key].positiveCount++;
        }
        
        if (item.sentiment_score !== null) {
          acc[key].sentimentSum += item.sentiment_score;
        }
        
        return acc;
      }, {});
      return questions
}

export const fallback = (req) => {
  return (
    <Paper sx={{ p: 2 }}>
      <Container>
      <Typography variant="body2" color="text.secondary">
          You do not have access { req }
        </Typography>
      </Container>
      </Paper>
  )
}